import { render, staticRenderFns } from "./AulaAluno.vue?vue&type=template&id=2a8cbc2e"
import script from "./AulaAluno.vue?vue&type=script&lang=js"
export * from "./AulaAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports